import { DATA_BINDING } from '@wix/app-definition-ids'
import { type SerializedCompStructure } from '@wix/document-services-types'

import { type DataBindingController } from '../types'

export function assertDataBindingController(
  component: SerializedCompStructure,
): asserts component is DataBindingController {
  const isDataBindingController =
    component.componentType === 'platform.components.AppController' &&
    component.data !== undefined &&
    component.data.applicationId === DATA_BINDING

  if (!isDataBindingController) {
    throw new Error('The component is not a data-binding controller.')
  }
}
